/**
 * bloom — a focal breathing BloomPulse (the Nexus vortex). Migrated from the
 * bloom half of the old softLightScene. Depth defaults to ATMOSPHERE inside
 * BloomPulse, matching the old behaviour.
 */
import { registerEffect, makeContentHandle, type EffectBuilder } from '../effectBuilders';
import { BloomPulse } from '../../vfx/BloomPulse';
import { Z_LAYERS } from '../../../rendering/Z_LAYERS';

const buildBloom: EffectBuilder = (layer, ctx) => {
  if (layer.kind !== 'bloom') return null;
  const bloom = new BloomPulse({ ...layer, parent: ctx.layerContainer });
  return makeContentHandle({ onDestroy: () => bloom.destroy() });
};

registerEffect({ kind: 'bloom', build: buildBloom, depth: Z_LAYERS.ATMOSPHERE });
